import { useCollectionData } from "react-firebase-hooks/firestore";
import { useSession } from "~/contexts/auth-context";
import { getProductsByWorkId } from "~/integrations/firebase/collections/products";
import { logError } from "~/shared/services/error-reporting";
import type { BundleFormat } from "~/pages/product-details/tabs/sales-data-tab/components/bundle/bundle.utils";

export const useBundleFormats = (workId: string | null | undefined) => {
  const { organisation } = useSession();

  const [products, isLoading, error] = useCollectionData(
    workId ? getProductsByWorkId(organisation.id, workId) : null,
  );

  if (error) {
    logError("Error loading bundle formats", { originalException: error });
  }

  const formats: BundleFormat[] = (products ?? []).map((product) => ({
    id: product.id,
    identifier: product.identifier,
    title: product.title,
    author: product.author,
    productGroup: product.productGroup,
    productGroupDescription: product.productGroupDescription,
    supplyDetails: product.supplyDetails,
  }));

  return { formats, isLoading, isError: Boolean(error) };
};
